import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";
import GroupFormFields from "./GroupFormFields.js";

class Create extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        label: PropTypes.string,
        buttonClass: PropTypes.string
    }

    render() {
        return (
            <ParadigmaModal
                postUrl={api.usuarios.grupos.create}
                onSubmit={(res) => this.props.onSubmit(res)}
                successMessage={"El Grupo ha sido creado con éxito."}
                title={"Nuevo Grupo"}
                buttonTitle={"Nuevo Grupo"}
                buttonIcon={"fa fa-plus fa-lg"}
                
                buttonLabel={this.props.label}
                saveButton={true}
                closeButton={true}
                buttonClass={this.props.buttonClass}
                className={"ui-modal-dialog"}
            >
                <div className="ui-form">
                    <GroupFormFields autoFocusFirstField={true} />
                </div>
            </ParadigmaModal>
        );
    }
}

export default Create;



// WEBPACK FOOTER //
// ./src/views/Usuarios/Grupos/Create.js